import React from "react";

import { Route, Redirect } from "react-router-dom";

import { getDefaultRoute, hasPermission } from "../utils/Permissions";

/**
 * ProtectedRoute component that checks permissions before allowing access to a route.
 * If the user doesn't have the required permission (explicitly false or missing),
 * redirects to their default route.
 *
 * @param {string} requiredPermission - The permission code required to access this route
 * @param {React.Component} component - The component to render if permission is granted
 * @param {boolean} exact - Whether the route should match exactly
 * @param {string} path - The route path
 * @param {object} rest - Any other props to pass to Route
 */
const ProtectedRoute = ({
  requiredPermission, component: Component, exact, path,
}) => {
  // If no permission is required, allow access (e.g., onboarding routes)
  if (!requiredPermission) {
    return <Route path={path} exact={exact} component={Component} />;
  }

  return (
    <Route
      path={path}
      exact={exact}
      render={(props) => {
        if (!hasPermission(requiredPermission)) {
          return <Redirect to={getDefaultRoute()} />;
        }

        return (
          <Component
            history={props.history}
            location={props.location}
            match={props.match}
          />
        );
      }}
    />
  );
};

export default ProtectedRoute;
